





import Vue from 'vue'
import Component from 'vue-class-component'
import moment from '@/plugins/moment'
@Component({
  props: {
    date: {
      type: Object as () => any,
      required: true,
    },
  },
})
export default class Countdown extends Vue {
  diff: any = null

  get dayDisplayString() {
    let res = this.days ? `${this.days} day` : ''
    if (this.days > 1) {
      res += 's'
    }
    return res
  }

  get days() {
    let days = Math.trunc(this.diff / 60 / 60 / 24)
    return days
  }

  get seconds() {
    let seconds = Math.trunc(this.diff % 60)
    return seconds > 9 ? seconds : `0${seconds}`
  }

  get minutes() {
    let minutes = Math.trunc(this.diff / 60) % 60
    return minutes > 9 ? minutes : `0${minutes}`
  }

  get hours() {
    return Math.trunc(this.diff / 60 / 60) % 24
  }
  mounted() {
    this.diff = this.$props.date.diff(moment()) / 1000
    if (this.diff >= 0) {
      setInterval(() => {
        this.diff = this.$props.date.diff(moment()) / 1000
      }, 1000)
    }
  }
}
